import { fetchProjectAsset } from "components/SmartSurveyor/SmartSurveyorV3/utils/signedAssetUrls";
import type { BOQExtractionData } from "./types";

export const fetchBOQExtraction = async (
  projectId: string,
): Promise<BOQExtractionData | null> => {
  try {
    const res = await fetchProjectAsset({
      projectId,
      key: `smart-surveyor/projects/${projectId}/agent_output/boq_extraction.json`,
    });
    if (!res.ok) return null;
    return (await res.json()) as BOQExtractionData;
  } catch {
    return null;
  }
};
